import { HelmetDexteel } from "@dexteel/mesf-core";
import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import { WaterMeterThresholdsForm } from "./components/WaterMeterThresholdsForm";

export const WaterMeterThresholdsPage = () => (
	<>
		<HelmetDexteel title="Water Meter Thresholds" />
		<Grid2 container justifyContent="center" p={1} spacing={1}>
			<Grid2
				container
				size={{ md: 12, xs: 12 }}
				spacing={1}
				direction={"column"}
			>
				<Grid2>
					<Typography variant="h5" fontWeight={600}>
						Water Meter Thresholds
					</Typography>
					<Typography variant="body2" color="textSecondary">
						Where each level of the Meters table on the Engineering Report
						starts. A level runs until the next one begins, so moving a boundary
						pushes the ones around it.
					</Typography>
				</Grid2>
			</Grid2>
			<Grid2 container justifyContent="center" alignItems="center">
				<Grid2 size={{ md: 12, xs: 12 }}>
					<WaterMeterThresholdsForm />
				</Grid2>
			</Grid2>
		</Grid2>
	</>
);
